'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var HTTP = require('ipfs-utils/src/http.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var HTTP__default =
/*#__PURE__*/
_interopDefaultLegacy(HTTP);

var createRm = configure.configure(function (api) {
  function rm(_x) {
    return _rm.apply(this, arguments);
  }

  function _rm() {
    _rm = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(path) {
      var options,
          res,
          body,
          error,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return api.post('files/rm', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: path
                }, options)),
                headers: options.headers
              });

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.text();

            case 6:
              body = _context.sent;

              if (!(body !== '')) {
                _context.next = 11;
                break;
              }

              error = new HTTP__default["default"].HTTPError(res);
              error.message = body;
              throw error;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _rm.apply(this, arguments);
  }

  return rm;
});
exports.createRm = createRm;